export const nav = {
    groups: {
        overview: "সারসংক্ষেপ",
        sales: "বিক্রি",
        catalog: "ক্যাটালগ",
        inventory: "ইনভেন্টরি",
        purchasing: "ক্রয়",
        finance: "হিসাব",
        pos: "পয়েন্ট অফ সেল",
        settings: "সেটিংস",
        account: "অ্যাকাউন্ট",
    },
    menu: "মেনু",
    dashboard: "ড্যাশবোর্ড",
    auditLog: "অডিট লগ",
    settings: "সেটিংস",
    sessions: "সেশন",
    security: "নিরাপত্তা",
    businessSettings: "ব্যবসার সেটিংস",
    products: "পণ্য",
    catalogSetup: "ক্যাটালগ সেটআপ",
    stock: "স্টক",
    stockAdjustments: "স্টক সমন্বয়",
    transfers: "ট্রান্সফার",
    stockCounts: "স্টক গণনা",
    orders: "অর্ডার",
    orderCalls: "কল তালিকা",
    deliveryZones: "ডেলিভারি জোন",
    orderReturns: "ফেরত",
    rtoParcels: "ফেরত পার্সেল",
    cod: "COD হিসাব",
    fraud: "ফ্রড চেক",
    onlineStore: "অনলাইন স্টোর",
    coupons: "কুপন",
    appearance: "দোকানের চেহারা",
    shopPages: "দোকানের পেজ",
    shopThemes: "দোকানের থিম",
    billing: "প্ল্যান ও বিলিং",
    support: "সাপোর্ট অ্যাক্সেস",
    dataAccount: "ডেটা ও অ্যাকাউন্ট",
    help: "সাহায্য",
    staff: "কর্মী",
    payments: "পেমেন্ট",
    posReview: "POS রিভিউ",
    posDevices: "POS ডিভাইস",
    couriers: "কুরিয়ার",
    paymentAccounts: "পেমেন্ট অ্যাকাউন্ট",
    reports: "রিপোর্ট",
    expenses: "খরচ",
    cashbook: "ক্যাশবুক",
    customers: "কাস্টমার",
    onlineAccounts: "অনলাইন অ্যাকাউন্ট",
    suppliers: "সরবরাহকারী",
    purchaseOrders: "পারচেজ অর্ডার",
    goodsReceipts: "গ্রহণ করা মাল",
    purchaseReturns: "সরবরাহকারীকে ফেরত",
    payables: "দেনা",
    imports: "ইমপোর্ট / এক্সপোর্ট",
    locations: "লোকেশন",
    openMenu: "মেনু খুলুন",
    closeMenu: "মেনু বন্ধ করুন",
    preferences: "পছন্দসমূহ",
    account: "অ্যাকাউন্ট",
    welcome: "স্বাগতম, {{name}}",
    dashboardBody: "এই ব্যবসার বিক্রি, স্টক ও অর্ডারের তথ্য এখানে দেখা যাবে।",
};
//# sourceMappingURL=nav.js.map